import { NgClass, NgStyle } from '@angular/common';
import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import dayjs from 'dayjs';
import { catchError, delay, EMPTY, retry } from 'rxjs';
import { RequestStateEnum } from '../../../enums/app.enum';
import { CheckInService } from '../../../services/check-in.service';
import { CardHeaderComponent } from '../../atoms/card-header/card-header.component';
import { CardComponent } from '../../atoms/card/card/card.component';
import { LeaderBoardPodiumEntryDTO } from './leader-board.types';

@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  imports: [CardComponent, CardHeaderComponent, NgClass, NgStyle],
})
export class LeaderBoardComponent implements OnInit, OnDestroy {
  public podium: WritableSignal<LeaderBoardPodiumEntryDTO[]> = signal([]);
  public maxCountCheckIns: WritableSignal<number> = signal(0);
  public userCheckInCount = 0;
  public fetchRequest: RequestStateEnum | null = null;

  private startDate = '';
  private endDate = '';
  private intervalId: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(private readonly checkInService: CheckInService) {}

  ngOnInit() {
    this.getLeaderBoard();

    this.intervalId = setInterval(() => {
      this.getLeaderBoard();
    }, 60000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public getWidth(item: LeaderBoardPodiumEntryDTO): string {
    const width = item.checkIns / this.maxCountCheckIns();
    return width ? `${Math.round((item.checkIns / this.maxCountCheckIns()) * 100)}%` : '10px';
  }

  public getNumberOfPeople(index: number): number {
    return this.podium().length > 0 ? this.podium()[index].numberOfPeople : 0;
  }

  public getCheckIns(index: number): number {
    return this.podium().length > 0 ? this.podium()[index].checkIns : 0;
  }

  public get headerSubtitle(): string {
    const startDate = dayjs(this.startDate);
    const endDate = dayjs(this.endDate);
    const endDateString = dayjs().isSame(endDate, 'day') ? 'heute' : endDate.format('DD.MM.YYYY');

    return startDate.isValid() && endDate.isValid()
      ? `${startDate.format('DD.MM.YYYY')} - ${endDateString}`
      : 'keine Informationen';
  }

  public getLeaderBoard(): void {
    this.fetchRequest = RequestStateEnum.PENDING;
    this.checkInService
      .getCheckInRanking()
      .pipe(
        retry(3),
        delay(2000),
        catchError(() => {
          this.fetchRequest = RequestStateEnum.ERROR;
          return EMPTY;
        })
      )
      .subscribe((response) => {
        this.fetchRequest = RequestStateEnum.SUCCESS;
        this.podium.set(response.payload.podium);
        this.maxCountCheckIns.set(response.payload.podium[0].checkIns);
        this.startDate = response.payload.periodStartDate;
        this.endDate = response.payload.periodEndDate;
        this.userCheckInCount = response.payload.userRanking?.checkIns ?? 0;
      });
  }

  protected readonly RequestStateEnum = RequestStateEnum;
}
